import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { useNavigate } from 'react-router'

export function CardActionsMenu({
  launchAppPath,
  workspaceDetailsPath,
}: {
  launchAppPath: string
  workspaceDetailsPath: string
}) {
  const navigate = useNavigate()
  // const canEditApp = useCanEditApp()

  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            // className="bg-offwhite size-8 rounded-full text-foreground hover:bg-primary/10 hover:text-foreground"
          >
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={() => navigate(launchAppPath)}>Launch Application</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => navigate(workspaceDetailsPath)}>Open Workspace</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
